import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCOzom1TkNoyB4H31EnmsKGWaxL1tB0xcU",
  authDomain: "vettechlearning-5f2df.firebaseapp.com",
  projectId: "vettechlearning-5f2df",
  storageBucket: "vettechlearning-5f2df.firebasestorage.app",
  messagingSenderId: "732197681356",
  appId: "1:732197681356:web:687d65e65d3ef6b995aa69"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
